import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ObjectLookupComponent } from './object-lookup.component';
import { StatusService } from 'app/server/services/status/status.service';

@Component({
  selector: 'app-status-object-lookup',
  templateUrl: './status-object-lookup.component.html',
  styleUrls: ['./object-lookup.component.scss']
})
export class StatusObjectLookupComponent extends ObjectLookupComponent {
  constructor(private statusService: StatusService) {
    super();
  }

  protected loadObjectByIdFromService(id: number) {
    // StatusService exposes a status$ for the current id; request the id then subscribe
    this.statusService.getStatus(id);
    this.statusService.status$.pipe(catchError(() => of(null))).subscribe((result: any) => {
      this.isLoadingObject = false;
      if (result) {
        this.selectedObject = result;
        this.searchTerm = this.getObjectName(result);
        this.isSearching = false;
      } else {
        this.selectedObject = null;
        this.searchResults = [];
        this.searchTerm = '';
        this.isSearching = true;
      }
    });
  }

  public getObjectType(): string {
    return 'Status';
  }

  protected searchObjects(searchText: string): Observable<any[]> {
    if (!searchText) {
      return of([]);
    }

    return this.statusService.statuses$.pipe(
      map((statuses) => statuses.filter((status) => status.Description.toLowerCase().includes(searchText.toLowerCase())))
    );
  }

  public getObjectName(item: any): string {
    return item?.Name || item?.Description || item?.Label || '';
  }

  public getObjectId(item: any): number | null {
    return item?.StatusID ?? item?.ID ?? null;
  }
}
